import { useHistory } from 'react-router-dom';

import { Typography, Box } from '@mui/material';

import { Button } from '../../components/common';
import colors from '../../assets/colors';

export default function DeletedAccountInfo() {
  const history = useHistory();
  return (
    <>
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ fontSize: 45, color: colors.agroweGreen, mt: 5 }}>
          Twoje konto zostało pomyślnie usunięte!
        </Typography>
        <Typography sx={{ fontSize: 30, color: colors.agroweGreen, mt: 5 }}>
          Rozwijamy się z myślą o Tobie. Mamy nadzieję, że zobaczymy się do
          następnych żniw.
        </Typography>
        <Button
          agroweGreen
          variant="outlined"
          onClick={() => history.push('/login')}
          sx={{ mt: 5 }}
        >
          PRZEJDŹ NA STRONĘ GŁOWNA
        </Button>
      </Box>
    </>
  );
}
